import { APIClient } from '@frontend/api-utils';
import { EquipmentStateName } from '@frontend/equipment/types';
import { PackageStateName } from '@frontend/package/types';
import { SlotStateName } from '@frontend/slot/types';
import { TransactionStateName } from '@frontend/transaction/types';

export class WorkflowStateClient extends APIClient {
    public static readonly endpoint = '/workflow-api/v1';

    public static async fetchAccountWorkflowPossibleStates(
        accountId: string,
        workflowId: string
    ): Promise<TransactionStateName[] | EquipmentStateName[] | PackageStateName[] | SlotStateName[]> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/workflows/${workflowId}/possible-states`);
        return await this.handleResponse<TransactionStateName[] | EquipmentStateName[] | PackageStateName[] | SlotStateName[]>(response);
    }

    public static async validateAccountWorkflowTransactionStates(accountId: string, workflowId: string): Promise<any> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/workflows/${workflowId}/validate-transaction-states`);
        return await this.handleResponse<any>(response);
    }
}
